import {t} from '../../common/getTranslations';
import {
  HistoryLineBannerTypeVo,
  HistoryLineBannerVo,
} from '../../common/shared/api/nicolas/vo/KakaoCashReportDataVo.interface';
import {TranslateKey} from '../../locale/type';
import {HistoryLineBanner, HistoryLineBannerType} from '../generated/types';

export function createHistoryLineBannerWithHistoryLineBanner(
  banner: HistoryLineBannerVo
): HistoryLineBanner {
  const {scheme, banner_type} = banner;
  const historyLineBanner = HISTORY_LINE_BANNER_MAP[banner_type];
  const translatedHistoryLineBanner = {
    ...historyLineBanner,
    title: t(historyLineBanner.titleKey),
    subTitle: t(historyLineBanner.subTitleKey),
  };

  return {scheme, ...translatedHistoryLineBanner};
}

const HISTORY_LINE_BANNER_MAP: Record<
  HistoryLineBannerTypeVo,
  Pick<HistoryLineBanner, 'bgColor' | 'bannerType'> & {
    titleKey: TranslateKey;
    subTitleKey: TranslateKey;
  }
> = {
  HELIX: {
    titleKey: 'cash_history_banner_title_1',
    subTitleKey: 'cash_history_banner_description_1',
    bgColor: '#8066E8',
    bannerType: HistoryLineBannerType.Helix,
  },
  RECENT: {
    titleKey: 'cash_history_banner_title_2',
    subTitleKey: 'cash_history_banner_description_2',
    bgColor: '#2487FC',
    bannerType: HistoryLineBannerType.Recent,
  },
  MILLION: {
    titleKey: 'cash_history_banner_title_3',
    subTitleKey: 'cash_history_banner_description_3',
    bgColor: '#10AD98',
    bannerType: HistoryLineBannerType.Million,
  },
};
